export default function Logo() {
    return (
        <h1>🌴 TRIP ESSENTIALS 🏖️</h1>
    );
}